import React from "react";
import { IoArrowBack } from "react-icons/io5";
import { toast } from "react-toastify";
import axios from "axios";

const DetailedTicketView = ({
  ticket,
  onClose,
  onStatusChange, // Optional: parent can pass this to update list
  isSidebarAdmin,
  employeeAccess,
  roleData,
}) => {
  if (!ticket) return null;

  const {
    _id,
    ticketNumber,
    fullname,
    email,
    phoneNumber,
    awbNumbers,
    category,
    subcategory,
    status,
    createdAt,
    company,
    message,
    isAdmin,
  } = ticket;

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const handleStatusChange = async (newStatus) => {
    try {
      const [session, token] = document.cookie.split("=");
      if (!token) {
        toast.error("Session expired. Please log in again.");
        return;
      }
      const headers = { authorization: `Bearer ${token}` };

      // Check access if props provided, else allow (for admin)
      let canUpdate = true;
      if (typeof isSidebarAdmin !== "undefined" && !isSidebarAdmin) {
        canUpdate =
          !!employeeAccess?.canUpdate && roleData?.isEmpActive === true;
      }

      if (canUpdate) {
        const response = await axios.put(
          `${REACT_APP_BACKEND_URL}/support/${_id}/status`,
          { status: newStatus },
          { headers }
        );
        if (response.status === 200) {
        //   toast.success(
        //     newStatus === "resolved"
        //       ? "Ticket marked as resolved!"
        //       : "Ticket marked as deleted!"
        //   );
          if (onStatusChange) onStatusChange(_id, newStatus);
          onClose();
        } else {
          toast.error("Failed to update ticket status. Try again.");
        }
      } else {
        toast.error("Unauthorized to update ticket status.");
      }
    } catch (error) {
      toast.error("Failed to update ticket status.");
    }
  };

  return (
    <div className="bg-gray-50 overflow-y-auto z-50 md:p-4 p-1 flex flex-col">
      <div className="w-full mx-auto bg-white rounded-lg shadow-lg p-4 md:p-10 flex-1 flex flex-col">
        {/* Header with back arrow */}
        <div className="flex items-center gap-2 mb-6">
          <button
            onClick={onClose}
            className="text-[#0CBB7D] hover:text-[#099e67] text-2xl"
          >
            <IoArrowBack />
          </button>
          <h2 className="text-2xl font-bold text-[#0CBB7D]">Ticket Details</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div>
            <p className="text-sm text-gray-500">Ticket ID</p>
            <p className="font-semibold text-base">{ticketNumber}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Status</p>
            <span
              className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${
                status === "resolved"
                  ? "bg-green-100 text-green-700"
                  : status === "deleted"
                  ? "bg-red-100 text-red-700"
                  : "bg-yellow-100 text-yellow-700"
              }`}
            >
              {status || "Pending"}
            </span>
          </div>
          <div>
            <p className="text-sm text-gray-500">Created On</p>
            <p>{createdAt ? new Date(createdAt).toLocaleString() : "N/A"}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Category</p>
            <p>{category || "N/A"}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Subcategory</p>
            <p>{subcategory || "N/A"}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Platform</p>
            <p>{isAdmin ? "Admin" : "User"}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div>
            <p className="text-sm text-gray-500">Name</p>
            <p>{fullname || "N/A"}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Email</p>
            <p>{email || "N/A"}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Phone</p>
            <p>{phoneNumber || "N/A"}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">AWB Number(s)</p>
            <p>
              {awbNumbers && awbNumbers.length > 0
                ? awbNumbers.join(", ")
                : "N/A"}
            </p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Company</p>
            <p>{company || "N/A"}</p>
          </div>
        </div>

        <div className="flex-1">
          <p className="text-sm text-gray-500 mb-1">Detailed Description</p>
          <div className="bg-gray-100 rounded p-3 text-gray-700 text-sm whitespace-pre-line">
            {message || "No message provided."}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between mt-8 gap-3 sm:gap-0">
          <button
            onClick={onClose}
            className="px-4 py-1.5 sm:px-6 sm:py-2 rounded bg-gray-200 text-gray-700 font-semibold text-sm sm:text-base hover:bg-gray-300 flex items-center justify-center"
          >
            <IoArrowBack className="inline mr-2" />
            Back
          </button>

          <div className="flex gap-2 sm:gap-3 flex-col sm:flex-row">
            <button
              className="px-4 py-1.5 sm:px-6 sm:py-2 rounded bg-[#0CBB7D] text-white font-semibold text-sm sm:text-base hover:bg-[#0aa66d]"
              onClick={() => handleStatusChange("resolved")}
            >
              Resolved
            </button>
            <button
              className="px-4 py-1.5 sm:px-6 sm:py-2 rounded bg-red-600 text-white font-semibold text-sm sm:text-base hover:bg-red-700"
              onClick={() => handleStatusChange("deleted")}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedTicketView;
